export default __webpack_public_path__ + "00379368a4dad8891d84fa4e60501081.png";